import styled from 'styled-components';
import { FONT_FAMILY, DEVICES, COLORS } from '@Commons';

export const PassportContainer = styled.div`
  .passport-wrapper {
    align-items: flex-start;
    margin-bottom: '48px';
  }
  .ui.search.selection.dropdown {
    width: 450px;
  }
  .MuiFormControl-marginNormal {
    margin-left: 0;
  }
`;
export const RowWrapper = styled.div`
  align-items: flex-start;
`;
export const Heading = styled.div`
  font-size: 28px;
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 38px;
  margin-bottom: 48px;
  text-align: center;
  margin-top: -26px;
  color: ${COLORS.black};
  @media ${DEVICES.tab} {
    margin-top: 0;
  }
`;
